const formatarTelefone = (telefone) => {
	if (!telefone) return '--';
	const isFixo = telefone.length === 10;
	const posicaoTraco = isFixo ? 6 : 7;
	return `(${telefone.slice(0, 2)}) ${telefone.slice(2, posicaoTraco)} - ${telefone.slice(posicaoTraco)}`;
};

export { formatarTelefone };
